"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const treeNode_1 = require("../../base/treeNode");
class NameTreeNode extends treeNode_1.TreeNode {
    constructor(content) {
        super();
        if (content == undefined || content == null) {
            this.content = [];
        }
        else {
            this.content = content;
        }
        console.log("calling nametreenode constructor");
    }
    setContent(content) {
        this.content = content;
    }
    getContent() {
        return this.content;
    }
}
exports.NameTreeNode = NameTreeNode;
